import type {
    CSSProperties
} from 'react';

// Keep status and description text available to assistive technology without affecting layout.
// Explicit pixels work in both React inline styles and MUI sx (where numeric 1 means 100%).
const visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
} satisfies CSSProperties;

export default visuallyHidden;
